import Image from "next/image";
import { Alert, Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Link from "next/link";
import { useRouter } from "next/router";
import { MdOutlineArrowDownward } from "react-icons/md";

//local imports
import classes from "@/styles/become-an-affiliate/become-an-affiliate-main.module.css";
import NoteSection from "../generic/note-section";
import { routes } from "@/utils/routes";
import { becomeAnAffiliate } from "@/utils/content";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function BecomeAnAffiliateMain() {
  const router = useRouter();
  const content = becomeAnAffiliate.en;
  const isMobile = useIsMobile();

  return (
    <main>
      <section className={`py-5 ${classes.hero}`}>
        <Container className={classes.container}>
          <Row>
            <Col className="d-flex align-items-center" xs={12} md={7}>
              <div>
                <h1>{content.title}</h1>
                <p>{content.para}</p>
              </div>
            </Col>
            <Col
              className="d-flex align-items-center justify-content-center"
              xs={12}
              md={5}
            >
              <Image
                src="https://cbpstaticfiles.blob.core.windows.net/sv-app/affiliate/becomeAnAffiliate.png"
                alt="Become An Affiliate Illustration"
                className={classes.bannerImage}
                height={300}
                width={300}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section className={`${isMobile ? "" : "my-5"}`}>
        <Container>
          <Alert>
            <NoteSection
              content={
                <>
                  <div>
                    <h5 id="four">Commissions</h5>
                    <p>
                      During the term of this Agreement, we will pay you in
                      Canadian Dollars (CAD $) as follows;
                    </p>
                    <ol>
                      <li>
                        Earn a $0.01 per Click commission for every new real
                        Click on your referral link.
                      </li>
                      <li>
                        Earn a $0.02 commission for every new customer who signs
                        up using your referrals.
                      </li>
                    </ol>
                    <p>and</p>
                    <ol>
                      <li>
                        Earn a commission per label for every shipment(Parcel,
                        LTL Freight, Skid shipment etc.,) created and sent by
                        your referrals for the first 90 days (3 months) using
                        our Shipvista.com’s default carrier accounts, including
                        Canada Post, Purolator, UPS, USPS, DHL Express, Tforce
                        Freight, Apex, and Day and Ross among others.
                        <table className="mt-4 table table-bordered w-75">
                          <tbody>
                            <tr>
                              <td>#</td>
                              <td>Per Label Amount(in $)</td>
                              <td>Earn</td>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>$0 - $199.99</td>
                              <td>Earn a $0.10 per label commission</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>$200 - $999.99</td>
                              <td>Earn 2% per label commission</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>$1000 and above</td>
                              <td>Earn 5% per label commission</td>
                            </tr>
                          </tbody>
                        </table>
                        <div>
                          Example: If a person you referred created a shipment
                          on our platform
                          <ul>
                            <li>
                              for postage amount worth $10 per label you will
                              receive $0.10 for that shipping label.
                            </li>
                            <li>
                              for postage amount worth $195 per label you will
                              receive $0.10 for that shipping label.
                            </li>
                            <li>
                              for postage amount worth $250 per label you will
                              receive 2%(i.e. $5) for that shipping label.
                            </li>
                            <li>
                              for postage amount worth $1100 per label you will
                              receive 5%(i.e. $55) for that shipping label.
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        Earn a $5.00 commission for each New REFERRALS that
                        signs up with any of our Paid Subscription Plans,
                        including Professional, Enterprise, and customizable
                        Plans among other paying plans.
                      </li>
                    </ol>
                    <br />
                  </div>
                  {/* <p>
                    We are currently harmonizing our program to offer more
                    benefits to our affiliates and the details on this page will
                    soon be updated.
                  </p>
                  <p>
                    <b>COMMISSION</b>
                  </p>
                  <p>
                    During the term of this Agreement, we will pay you in
                    Canadian Dollars (CAD $) as follows;
                  </p>
                  <ol>
                    <li>
                      Earn a $0.01 per Click commission for every new real Click
                      on your referral link.
                    </li>
                    <li>
                      {" "}
                      Earn a $0.02 commission for every new customer who signs
                      up using your referrals.
                    </li>
                  </ol>
                  <p>and</p>
                  <ol>
                    <li>
                      Earn a $0.10 per label commission for every shipment or
                      parcel created and sent by your referrals for the first 90
                      days (3 months) using our Shipvista.com’s default carrier
                      accounts, including Canada Post, Purolator, UPS, USPS, and
                      DHL Express among others.
                    </li>
                    <li>
                      Earn a 5% per commission for every pallet shipment (LTL
                      Freight, Skid shipment) created and sent by your referrals
                      for the first 90 days (3 months) using our Shipvista.com’s
                      default carrier accounts, including Tforce Freight, Apex,
                      and Day and Ross among others.
                    </li>
                    <li>
                      Earn a $5.00 commission for each New REFERRALS that signs
                      up with any of our Paid Subscription Plans, including
                      Professional, Enterprise, and customizable Plans among
                      other paying plans.
                    </li>
                  </ol> */}
                  <Link href={routes.commissionProgramAgreement}>
                    {content.newCommissionProgram}
                  </Link>

                  {/* <p>{content.para2}</p>
                  <p>
                    <b>{content.subHeading2}</b>
                  </p>
                  <p>{content.subPara2}</p>
                  <ol>
                    {content.list2?.map((c, i) => (
                      <li key={i}>{c}</li>
                    ))}
                  </ol>
                   */}
                </>
              }
            />
          </Alert>
        </Container>
      </section>
      {/* <section className={`${isMobile ? "" : "my-5"}`}>
        <Container>
          <div className="py-5">
            <h2 className="text-center text-secondary">{content.title3}</h2>
          </div>
          <Row>
            <Col className="d-flex align-items-center">
              <div className="text-secondary">
                <h4>{content.subHeading3}</h4>
                <p>{content.para3}</p>
              </div>
            </Col>
            <Col sm="3" className="d-flex align-items-center">
              <Card className={classes.card}>
                <CardBody className="text-center">
                  <h5>{content.readyToGetStarted}</h5>
                  <p>{content.getStartedPara}</p>
                  <Button
                    className={classes.signUpButton}
                    onClick={() => router.push(routes.register)}
                  >
                    {content.signUpNow}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* <section className={`${isMobile ? "pt-5" : "my-5"}`}>
        <Container>
          <Row>
            <Col className="d-flex align-items-center">
              <div className="text-secondary">
                <h4>{content.title4}</h4>
                <ol className={classes.infoList}>
                  {content.list4?.map((a, i) => (
                    <li key={i}>{a}</li>
                  ))}
                </ol>
              </div>
            </Col>
            <Col
              sm="3"
              className="d-flex align-items-center justify-content-center"
            >
              <Card className={classes.card}>
                <CardBody className="text-center">
                  <div className={classes.infoCard}>
                    <h4 className="h5">{content.subHeading4}</h4>
                    <MdOutlineArrowDownward />
                    <h4 className="h5">{content.subHeading4_2}</h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section> */}
      <section
        className={`container text-secondary py-5 ${isMobile ? "" : "my-5"}`}
      >
        <div className={classes.infoText}>
          <h4>{content.title5}</h4>
          <ol className={classes.infoList}>
            {content.list5?.map((l, i) => (
              <li key={i}>{l}</li>
            ))}
          </ol>
        </div>{" "}
      </section>
    </main>
  );
}
